import React from 'react';
import { Link } from 'react-router-dom';
import { Plug, ArrowRight } from 'lucide-react';

const Integrations = () => {
  return (
    <section id="integrations" className="my-20">
      <div className="text-center mb-10">
        <div className="inline-block mb-4">
          <div className="flex items-center justify-center px-4 py-1.5 rounded-full bg-sortio-primary/10 border border-sortio-primary/20">
            <Plug className="mr-2 text-sortio-primary" size={14} />
            <span className="text-xs font-medium uppercase tracking-wider text-sortio-primary">
              Shipping: Buildium and Rent Manager integrations
            </span>
          </div>
        </div>
        <h2 className="text-3xl sm:text-4xl font-semibold mb-4 tracking-tight text-apple-50">
          Built for Buildium and Rent Manager
        </h2>
      </div>

      <div className="bg-apple-800/40 backdrop-blur-sm rounded-2xl border border-apple-700/50 p-8 sm:p-10 max-w-3xl mx-auto space-y-5">
        <p className="text-apple-200 text-base sm:text-lg leading-relaxed">
          The Buildium and Rent Manager integrations are shipping in the next Sortio release
          alongside dotloop and Zotero. Buildium uses an API-key auth flow against your Buildium
          account; Rent Manager uses the rmAPI / WAPI12 partner program with token auth. Both pull
          your property, unit, lease, and work order entities directly into the matcher so a file
          routed to "1127 Cornell Apt 4B" uploads to the right unit, lease, and work order
          attachment slot.
        </p>
        <p className="text-apple-200 text-base sm:text-lg leading-relaxed">
          Until then, Sortio works alongside both platforms via the filesystem: point it at the
          local sync folder your Buildium or Rent Manager exports write to, or at your Downloads
          folder, and it routes the documents into clean per-unit folders on disk. You upload
          through the platform UI as you do today, just with files that are already named and
          organized.
        </p>
        <p className="text-apple-200 text-base sm:text-lg leading-relaxed">
          For property managers on AppFolio, Yardi Breeze, or other platforms: the filesystem
          workflow above already works. Native AppFolio integration is on the Tier 2 roadmap once
          the BD work clears.
        </p>
        <div className="pt-4 flex flex-wrap gap-4">
          <Link to="/integrations" className="inline-flex items-center text-sortio-primary hover:text-sortio-secondary transition-colors text-sm font-medium">
            See all integrations <ArrowRight className="ml-1.5" size={14} />
          </Link>
          <Link to="/for-real-estate" className="inline-flex items-center text-sortio-primary hover:text-sortio-secondary transition-colors text-sm font-medium">
            Real estate workflow <ArrowRight className="ml-1.5" size={14} />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Integrations;
